/* tslint:disable */
import { SizingResultOptimum } from './sizing-result-optimum';
import { SizingOptimumData } from './sizing-optimum-data';

/**
 */
export class ViewSizingResultOptimum {
    result?: SizingResultOptimum;
    selectedEquipment?: SizingOptimumData;
    availableEquipment?: SizingOptimumData;
    dataGrapChart?: SizingOptimumData;
    productFlowRate?: number;
    imageSizing?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-sizing-result-optimum.ts